export * from './tab-config.view';